import * as UrlParse from 'url-parse';

export function getUnityLpRegParams() {
    return isUnityLanding() ? 'state=downloadClient' : '';
}

export function isUnityLanding() {
    return $('html').hasClass('landing-unity');
}


export function appendUnityLoginIframe(url: string) {
    const iframe = $<HTMLIFrameElement>('<iframe>');
    const iframeCss = {
        height: 0,
        left: -10,
        position: 'absolute',
        top: -10,
        width: 0
    };

    iframe[0].src = url;
    iframe.css(iframeCss);
    $('body').append(iframe);
}

export function addClientTypeParam(url: string): string {
    const parsedUrl = UrlParse(url, true);
    parsedUrl.set('query', {
        ...parsedUrl.query,
        clientType: 'webgl'
    });
    return parsedUrl.toString();
}

export function addLpLoginParam(url: string): string {
    const parsedUrl = UrlParse(url, true);
    parsedUrl.set('query', {
        ...parsedUrl.query,
        lpLogin: 'yes'
    });
    return parsedUrl.toString();
}
